import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 55px;
  height: 190px;
  justify-content: space-between;
`

export const RelationItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`
